export default __webpack_public_path__ + "static/media/Atharv.04969d47.jpeg";